import { setFilter } from '../State/filters';
import { setPagination } from '../State/pagination';
import fetchSuppliers from '../Services/fetchSuppliers';

export default (key, value) => async (dispatch) => {
  dispatch(setFilter({ key, value }));
  dispatch(setPagination({ current: 1 }));
  dispatch(fetchSuppliers());
}
